// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3nQAy","Background":"Layout_Background__2DhUi","Play":"Layout_Play__23Yq0","Content":"Layout_Content__2hFhH"};